import { Injectable } from '@angular/core';
import { 
  CanActivate, 
  ActivatedRouteSnapshot, 
  RouterStateSnapshot, 
  Router 
} from '@angular/router';
import { SharedService } from '../services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private sharedService: SharedService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Check if user is logged in (using existing property from SharedService)
    if (this.sharedService.logged_in_user && this.sharedService.logged_in_user.user_id) {
      return true;
    }

    // Restore from cached session on hard reloads.
    // The actual authentication is enforced server-side via the httpOnly cookie.
    // cached_user in localStorage is only a UI hint — the cookie is sent automatically.
    try {
      const cachedUser = localStorage.getItem('cached_user');
      if (cachedUser) {
        const parsedUser = JSON.parse(cachedUser);
        if (parsedUser?.user_id) {
          this.sharedService.logged_in_user = parsedUser;
          return true;
        }
      }
    } catch (err) {
      console.warn('Failed to parse cached_user from localStorage.', err);
    }

    // Not logged in so redirect to login page
    console.warn('Unauthorized access blocked. Redirecting to login.');
    this.sharedService.logged_in_user = null as any;
    this.router.navigate(['/login']);
    return false;
  }
}
